import { ax } from "./index";

// Get the API base URL from environment variables
let apiURL = import.meta.env.VITE_API_BASE_URL;

export default class ApplicationService {

  
  uploadSalesTotal(payload) {
    return ax.post(`${apiURL}sales-total/upload`, payload);
  }

  uploadSalesBudget(payload) {
    return ax.post(`${apiURL}sales-total/budget/upload`, payload);
  }

  getSalesTotalGrouped(payload) {
    return ax.post(`${apiURL}sales-total/grouped`, payload);
  }

  getSalesBudgetGrouped(payload) {
    return ax.post(`${apiURL}sales-total/budget/grouped`, payload);
  }

  importforecast(payload) {
    return ax.post(`${apiURL}fcb/import-forecast`, payload);
  }

  forecastandbudget(payload) {
    return ax.post(`${apiURL}fcb/lst`, payload);
  }
  forecastlistdetails(payload) {
    return ax.post(`${apiURL}fcb/lstdetails`, payload);
  }
  updateForecastBudget(payload) {
    const { id, ...result } = payload;
    return ax.put(`${apiURL}fcb/${id}`, result);
  }

  getforecastingYears() {
    return ax.get(`${apiURL}fcb/fc-year`);
  }

  getSaleslabYear() {
    return ax.get(`${apiURL}slap/sl-year`);
  }

  getSalesLab(payload) {
    return ax.post(`${apiURL}slap/lst`, payload);
  }

  importSalesLab(payload) {
    return ax.post(`${apiURL}slap/import-saleslap`, payload);
  }

  exportSalesLab(payload) {
    return ax.post(`${apiURL}slap/export-saleslap`, payload, {
      responseType: 'blob',  // Important to indicate we're expecting a file
    });
  }

  exportForecastBudget(payload) {
    return ax.post(`${apiURL}fcb/export-fcb`, payload, {
      responseType: 'blob',  // Important to indicate we're expecting a file
    });
  }

  exportForecastDetails(payload) {
    return ax.post(`${apiURL}fcb/export-details-fcb`, payload, {
      responseType: 'blob',  // Important to indicate we're expecting a file
    });
  }
  // 1. Get Reasons (GET request)
  getReasons() {
    return ax.post(`${apiURL}gpsreason/lst`);
  }

  // 2. Create Reason (POST request)
  createReason(payload) {
    return ax.post(`${apiURL}gpsreason/`, payload);
  }

  // 3. Update Reason (PUT request)
  updateReason(id, payload) {
    return ax.put(`${apiURL}gpsreason/${id}`, payload);
  }

  // 4. Delete Reason (DELETE request)
  deleteReason(id) {
    return ax.delete(`${apiURL}gpsreason/${id}`);
  }

  updateSalesLap = (payload) => {
    return ax.put(`${apiURL}slap/upd`, payload);
  };

  // 1. Get forecast and budget history (POST request)
  getForecastHistory(payload) {
    return ax.post(`${apiURL}fcb/history/lst`, payload);
  }

  // 2. view specific forecast and budget history (POST request)
  viewForecastHistory(id, payload) {
    return ax.post(`${apiURL}fcb/history/${id}`, payload);
  }

  // 3. Get sales lap history (POST request)
  getSalesLapHistory(payload) {
    return ax.post(`${apiURL}slap/history/lst`, payload);
  }

  // 4. view specific sales lap history (POST request)
  viewSalesLapHistory(id, payload) {
    return ax.post(`${apiURL}slap/history/${id}`, payload);
  }

  getBudgetForecastActuals(payload) {
    return ax.post(`${apiURL}fcb/budget-forecast-actuals`, payload);
  }

  updateSalesTotal(payload) {
    return ax.post(`${apiURL}sales-total/update`, payload);
  }

  updateSalesBudget(payload) {
    return ax.post(`${apiURL}sales-total/budget/update`, payload);
  }

  getSalesTotalYears() {
    return ax.get(`${apiURL}sales-total/st-year`);
  }

  getSalesBudgetYears() {
    return ax.get(`${apiURL}sales-total/budget/sb-year`);
  }

  getSalesTotalCustomers() {
    return ax.get(`${apiURL}sales-total/customers`);
  }

  getBudgetForecastActualsYears() {
    return ax.get(`${apiURL}fcb/bfa-year`);
  }

  async post(endpoint, payload) {
    try {
      const response = await ax.post(`${apiURL}${endpoint}`, payload);
      return response;
    } catch (error) {
      console.error(`Error in POST ${endpoint}:`, error);
      throw error;
    }
  }

  exportForecastDetailsExcel(payload) {
    return ax.post(`${apiURL}sales-total/forecast-details/export`, payload, {
      responseType: 'blob',
    });
  }

  exportSalesTotalExcel(payload) {
    return ax.post(`${apiURL}sales-total/export`, payload, {
      responseType: 'blob',
    });
  }

  exportSalesBudgetExcel(payload) {
    return ax.post(`${apiURL}sales-total/budget/export`, payload, {
      responseType: 'blob',
    });
  }

}
